import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Dropdown, Avatar, Space } from 'antd';
import {
    ProjectOutlined,
    UserOutlined,
    BankOutlined,
    LogoutOutlined,
    DownOutlined,
} from '@ant-design/icons';
import { useClientAuth, useClientAuthDispatch } from '../../context/ClientAuthContext';

const { Header, Sider, Content } = Layout;

const BRAND_YELLOW = '#FED230';
const BRAND_BLACK = '#1B1B1B';

const styles = {
    layout: {
        minHeight: '100vh',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: BRAND_BLACK,
        padding: '0 24px',
        height: 56,
        lineHeight: '56px',
    },
    logo: {
        color: BRAND_YELLOW,
        fontSize: 18,
        fontWeight: 700,
        letterSpacing: 1,
        cursor: 'pointer',
    },
    userSection: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    userName: {
        color: '#fff',
        marginLeft: 8,
        fontSize: 14,
    },
    dropdownIcon: {
        color: '#fff',
        fontSize: 10,
        marginLeft: 4,
    },
    sider: {
        background: '#fff',
        borderRight: '1px solid #f0f0f0',
    },
    content: {
        padding: 24,
        background: '#f5f5f5',
        minHeight: 'calc(100vh - 56px)',
        overflow: 'auto',
    },
    menuItem: {
        fontWeight: 500,
    },
};

const ClientPortalLayout = () => {
    const { contact } = useClientAuth();
    const dispatch = useClientAuthDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        dispatch({ type: 'logout' });
        navigate('/client-section/login');
    };

    const contactName = contact
        ? `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || contact.email
        : 'Client';

    const isSuper = contact?.isSuper === true || contact?.isSuper === 1;

    const profileMenuItems = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: 'My Profile',
            onClick: () => navigate('/client-section/profile'),
        },
        { type: 'divider' },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Logout',
            onClick: handleLogout,
            danger: true,
        },
    ];

    // Determine selected menu key from path
    const getSelectedKey = () => {
        const path = location.pathname;
        if (path.includes('/company')) return 'company';
        if (path.includes('/profile')) return 'profile';
        return 'projects';
    };

    const sidebarItems = [
        {
            key: 'projects',
            icon: <ProjectOutlined />,
            label: 'My Projects',
            style: styles.menuItem,
            onClick: () => navigate('/client-section'),
        },
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: 'Profile',
            style: styles.menuItem,
            onClick: () => navigate('/client-section/profile'),
        },
    ];

    if (isSuper) {
        sidebarItems.push({
            key: 'company',
            icon: <BankOutlined />,
            label: 'My Company',
            style: styles.menuItem,
            onClick: () => navigate('/client-section/company'),
        });
    }

    return (
        <Layout style={styles.layout}>
            <Header style={styles.header}>
                <div
                    style={styles.logo}
                    onClick={() => navigate('/client-section')}
                >
                    MEDIATROPY
                </div>
                <Dropdown menu={{ items: profileMenuItems }} trigger={['click']}>
                    <Space style={styles.userSection}>
                        <Avatar
                            size="small"
                            icon={<UserOutlined />}
                            style={{ backgroundColor: BRAND_YELLOW, color: BRAND_BLACK }}
                        />
                        <span style={styles.userName}>{contactName}</span>
                        <DownOutlined style={styles.dropdownIcon} />
                    </Space>
                </Dropdown>
            </Header>
            <Layout>
                <Sider width={220} style={styles.sider} breakpoint="lg" collapsedWidth={0}>
                    <Menu
                        mode="inline"
                        selectedKeys={[getSelectedKey()]}
                        items={sidebarItems}
                        style={{ borderRight: 0, paddingTop: 8 }}
                    />
                </Sider>
                <Content style={styles.content}>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default ClientPortalLayout;
